import React, { useEffect, useMemo, useState } from 'react'
import { Grid } from '@material-ui/core'
import { Button, SelectInput } from 'src/components'
import { useFormContext } from 'react-hook-form'
import { useStyles } from './styles'
import { MovimentationForm } from 'src/@types/validations/Animal'
import { LotDto } from 'src/dto/lot.dto'
import { PastureDto } from 'src/dto/pasture.dto'
import { useGetAnimalListByLot } from 'src/hooks/api/animal/useGetAnimalListByLot'
import { SelectAnimalModal } from 'src/components/SelectAnimalModal'

interface LoteMovimentationProps {
  lotList: LotDto[]
  pastureList: PastureDto[]
  isSaving: boolean
}

export const LoteMovimentation: React.FC<LoteMovimentationProps> = ({ lotList, pastureList, isSaving }) => {
  const [isOpenSelectedAnimalLotModal, setIsOpenSelectedAnimalLotModal] = useState<boolean>(false)

  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors }
  } = useFormContext<MovimentationForm>()

  const styles = useStyles()

  const selectedLoteOrigem = watch('loteOrigem')
  const selectedLoteDestino = watch('loteDestino')
  const selectedAnimals = watch('animals') || []

  const { data: animalListByLoteList } = useGetAnimalListByLot(selectedLoteOrigem!)

  const animalList = useMemo(() => animalListByLoteList || [], [animalListByLoteList])

  useEffect(() => {
    if (!selectedLoteOrigem) return

    if (!animalListByLoteList?.length) {
      setValue('animals', [])
      return
    }

    const allIds = animalListByLoteList.map((animal) => animal.idAnimal!)
    setValue('animals', allIds)
  }, [selectedLoteOrigem, animalListByLoteList])

  return (
    <>
      <div className={styles.inputWithEditToggle}>
        <SelectInput
          label='Lote origem'
          selectBy='idLote'
          showBy={['descricao']}
          options={lotList.filter((lot) => lot.idLote !== selectedLoteDestino)}
          value={watch('loteOrigem') || ''}
          // disabled={!!saleData?.idVenda}

          error={errors?.animals?.['message']}
          placeholder='Selecionar lote de origem'
          onChange={(item: any) => {
            setValue('loteOrigem', item.id)
            clearErrors('animals')
          }}
        />

        {selectedAnimals.length > 1 && (
          <div className={styles.selectedAnimalsContainer}>
            <span className={styles.selectedAnimalsCount}>Animais selecionados: {selectedAnimals?.length || 0}</span>
            <Button
              className={styles.buttonWrapper}
              type='button'
              disabled={isSaving}
              onClick={() => setIsOpenSelectedAnimalLotModal(true)}
            >
              Selecionar Animais
            </Button>
          </div>
        )}

        <Grid container spacing={3} style={{ marginTop: 8 }}>
          <Grid item xs={12} sm={6} style={{ padding: '0px 12px' }}>
            <SelectInput
              label='Lote destino'
              selectBy='idLote'
              showBy={['descricao']}
              options={lotList.filter((lot) => lot.idLote !== selectedLoteOrigem)}
              value={watch('loteDestino') || ''}
              // disabled={!!saleData?.idVenda}

              error={errors?.loteDestino?.message}
              placeholder='Selecionar lote de destino'
              onChange={(item: any) => {
                setValue('loteDestino', item.id)
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ padding: '0px 12px' }}>
            <SelectInput
              label='Pasto destino'
              selectBy='idPasto'
              showBy={['descricao']}
              options={pastureList}
              value={watch('pastoDestino') || ''}
              // disabled={!!saleData?.idVenda}

              error={errors?.pastoDestino?.message}
              placeholder='Selecionar pasto de destino'
              onChange={(item: any) => {
                setValue('pastoDestino', item.idPasto)
              }}
            />
          </Grid>
        </Grid>
      </div>

      <SelectAnimalModal
        animals={animalList}
        isOpen={isOpenSelectedAnimalLotModal}
        onClose={() => setIsOpenSelectedAnimalLotModal(false)}
        value={watch('animals') || []}
        onChange={(val) => setValue('animals', val)}
      />
    </>
  )
}
